<template>
  <fragment>
    <div v-if="!authenticated">
     
      <transition name="transition-routing" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <div class="app" v-if="authenticated">
      <div id="infobar-settings-sidebar" class="infobar-settings-sidebar">
        <div
          class="infobar-settings-sidebar-head d-flex w-100 justify-content-between"
        >
          <h4>Settings</h4>
          <a
            href="#"
            id="infobar-settings-close"
            class="infobar-settings-close"
          >
            <img
              src="assets/images/svg-icon/close.svg"
              class="img-fluid menu-hamburger-close"
              alt="close"
            />
          </a>
        </div>
      </div>
      <div class="infobar-settings-sidebar-overlay"></div>
      <!-- End Infobar Setting Sidebar -->
      <!-- Start Containerbar -->
      <div id="containerbar">
        <!-- Start Leftbar -->
        <div class="leftbar">
          <!-- Start Sidebar -->
          <div class="sidebar">
            <!-- Start Logobar -->
            <div class="logobar">
              <a href="index.html" class="logo logo-large">
                <img
                  src="assets/images/logo.svg"
                  class="img-fluid"
                  alt="logo"
                />
                
              </a>
              <a href="index.html" class="logo logo-small">
                <img
                  src="assets/images/small_logo.svg"
                  class="img-fluid"
                  alt="logo"
                />
               
              </a>
            </div>
            <!-- End Logobar -->
            <!-- Start Navigationbar -->
            <div class="navigationbar" >
           
              <ul class="vertical-menu" >
                <li  v-if="cuser.roles !='user'">
                  <a href="#/contract/list">
                    <img
                      src="assets/images/svg-icon/dashboard.svg"
                      class="img-fluid"
                      alt="dashboard"
                    />
                    <span>Dashboard</span>
                  </a>
                </li>
                <router-link tag="li" to="/contract/list">
                  <a href="#/contract/list">
                    <img
                      src="assets/images/svg-icon/pages.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>Contratti</span>
                  </a>
                </router-link>
                 <li v-if="cuser.roles =='superoperator'">
                    <router-link :to="{ name: 'route-contract-list-state', params: { state: '16' }}">
                
                    <img
                      src="assets/images/svg-icon/pages.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>Da Fatturare</span>
                
                </router-link>
                 </li>
                  <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-contract-list-state', params: { state: '201' }}">
                
                    <img
                      src="assets/images/svg-icon/pages.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>Fatturate</span>
                
                </router-link>
                </li>
                 <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-contract-list-state', params: { state: '200' }}">
                
                    <img
                      src="assets/images/svg-icon/pages.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>Archivio</span>
                
                </router-link>
                </li>
                <router-link tag="li" to="/inbox" v-if="cuser.roles =='superoperator' || cuser.roles =='commercialoperator'  || cuser.roles =='operator'">
                  <a href="#/inbox">
                    <img
                      src="assets/images/svg-icon/email.svg"
                      class="img-fluid"
                      alt="basic"
                    />
                    <span>In Box </span>
                    <span class="badge badge-info ml-5" v-if="mailToProcess">{{
                      mailToProcess
                    }}</span>
                  </a>
                </router-link>

                <li  v-if="cuser.roles =='superoperator'">
                    <a href="javaScript:void();">
            <img
              src="assets/images/svg-icon/layouts.svg"
              class="img-fluid"
              
            /><span>Templates</span
            ><i class="feather icon-chevron-right pull-right"></i>
          </a>
                <ul class="vertical-submenu">
                   <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-templatecategory-list'}">
                
                   <span>Categoria Templates</span>
                  </router-link>
                   </li>
                 
                     <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-template-list'}">
                
                    <span>Templates</span>
                
                </router-link>
                </li>
                  <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-signature-list'}">
                
                   
                    <span>Firme</span>
                
                </router-link>
                </li>
                <li v-if="cuser.roles =='superoperator'">
                  <router-link :to="{ name: 'route-emailtemplate-list'}">
                
                    <span>Email Cambio stato</span>
                
                </router-link>
                </li>
                  </ul>
                
                </li>
                
                  
              </ul>
            </div>
            <!-- End Navigationbar -->
          </div>
          <!-- End Sidebar -->
        </div>
        <!-- End Leftbar -->
        <!-- Start Rightbar -->
        <div class="rightbar">
          <!-- Start Topbar Mobile -->
          <div class="topbar-mobile">
            <div class="row align-items-center">
              <div class="col-md-12">
                <div class="mobile-logobar">
                  <a href="index.html" class="mobile-logo">
                    <img
                      src="assets/images/logo.svg"
                      class="img-fluid d-none"
                      alt="logo"
                    />
                    Riscatti Leasing
                  </a>
                </div>
                <div class="mobile-togglebar">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <div class="topbar-toggle-icon">
                        <a
                          class="topbar-toggle-hamburger"
                          href="javascript:void();"
                        >
                          <img
                            src="assets/images/svg-icon/horizontal.svg"
                            class="img-fluid menu-hamburger-horizontal"
                            alt="horizontal"
                          />
                          <img
                            src="assets/images/svg-icon/verticle.svg"
                            class="img-fluid menu-hamburger-vertical"
                            alt="verticle"
                          />
                        </a>
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div class="menubar">
                        <a class="menu-hamburger" href="javascript:void();">
                          <img
                            src="assets/images/svg-icon/collapse.svg"
                            class="img-fluid menu-hamburger-collapse"
                            alt="collapse"
                          />
                          <img
                            src="assets/images/svg-icon/close.svg"
                            class="img-fluid menu-hamburger-close"
                            alt="close"
                          />
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Start Topbar -->
          <div class="topbar">
            <!-- Start row -->
            <div class="row align-items-center">
              <!-- Start col -->
              <div class="col-md-12 align-self-center">
                <div class="togglebar">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <div class="menubar">
                        <a class="menu-hamburger" href="javascript:void();">
                          <img
                            src="assets/images/svg-icon/collapse.svg"
                            class="img-fluid menu-hamburger-collapse"
                            alt="collapse"
                          />
                          <img
                            src="assets/images/svg-icon/close.svg"
                            class="img-fluid menu-hamburger-close"
                            alt="close"
                          />
                        </a>
                      </div>
                    </li>
                    <li class="list-inline-item d-none">
                      <div class="searchbar">
                        <form>
                          <div class="input-group">
                            <input
                              type="search"
                              class="form-control"
                              placeholder="Search"
                              aria-label="Search"
                              aria-describedby="button-addon2"
                            />
                            <div class="input-group-append">
                              <button
                                class="btn"
                                type="submit"
                                id="button-addon2"
                              >
                                <img
                                  src="assets/images/svg-icon/search.svg"
                                  class="img-fluid"
                                  alt="search"
                                />
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
                <infobar />
              </div>
              <!-- End col -->
            </div>
            <!-- End row -->
          </div>
          <!-- End Topbar -->
          <!-- Start Breadcrumbbar -->
          <breadcrumb />

          <!-- End Breadcrumbbar -->
          <!-- Start Contentbar -->
          <div class="contentbar">
            <transition name="transition-routing" mode="out-in">
             
              <router-view :key="$route.fullPath"></router-view>
            </transition>
            <!-- Start row -->

            <!-- End row -->
          </div>
          <!-- End Contentbar -->
        </div>
        <!-- End Rightbar -->
      </div>
    </div>
    <app-footer v-if="authenticated" />
    <notifications
                   position="top right"
                   />

  </fragment>
</template>
<style>
/* Import Font Awesome Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Font Awesome Icons Set */

@import "~font-awesome/css/font-awesome.min.css";
@import "~bootstrap/dist/css/bootstrap.css";

@import "~bootstrap-vue/dist/bootstrap-vue.css";


.dataTables_length .custom-select {
  width: 31% !important;
}
.b-calendar {

  z-index: 999;
}

</style>
<style lang="scss">
// Import Main styles for this application
@import "./scss/style";
</style>

<script>

import AppLoader from "@/components/AppLoader.vue";
import AppInfoBar from "@/components/AppInfoBar.vue";
import axios from "axios";

import { Breadcrumb, AppFooter } from "./components/";

export default {
  data() {
    return { mailToProcess: 0 };
  },
  computed: {
    authenticated() {
      return this.$store.getters.isAuthenticated;
    },
    operarators() {
      return this.$store.state.operarators;
    },
    cuser() {
      return this.$store.state.user;
    },
  },
  components: {
    AppLoader,
    infobar: AppInfoBar,
    /* AppHeader,
            Sidebar,
            AppAside,*/
    AppFooter,
    Breadcrumb,
  },
  methods: {
    toProcess: function () {
      var me = this;
      axios.get("inboxemail/toprocess").then((response) => {
        me.mailToProcess = parseInt(response.data);
        setTimeout(me.toProcess, 10000);
      });
    },

    isInRole(role) {
      if(this.cuser)
      for (var i = 0; i < this.cuser.roles.length; i++) {
        if (this.cuser.roles[i] == role) {
          return true;
        }
      }
      return false;
    }},
  mounted() {
    var me = this;
    $(document).on("click", ".edit-action", window.EditAction);
     $(document).on("click", ".remove-action", function () {
      var url = $(this).data("url");
      me.$swal({
        title: ``,
        html: `Sicuri di eliminare la risorsa?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.delete(url).then((response) => {
            me.$swal({
              title: "Cancellazione avvenuta con successo",
              text: "",
              type: "success",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });

            this.$router.go();
          });
        }
      });
    });

    setTimeout(this.toProcess, 2000);
    $.sidebarMenu = function (menu) {
      var animationSpeed = 300,
        subMenuSelector = ".vertical-submenu";
      $(menu).on("click", "li a", function (e) {
        var $this = $(this);
        var checkElement = $this.next();
        if (checkElement.is(subMenuSelector) && checkElement.is(":visible")) {
          checkElement.slideUp(animationSpeed, function () {
            checkElement.removeClass("menu-open");
          });
          checkElement.parent("li").removeClass("active");
        } else if (
          checkElement.is(subMenuSelector) &&
          !checkElement.is(":visible")
        ) {
          var parent = $this.parents("ul").first();
          var ul = parent.find("ul:visible").slideUp(animationSpeed);
          ul.removeClass("menu-open");
          var parent_li = $this.parent("li");
          checkElement.slideDown(animationSpeed, function () {
            checkElement.addClass("menu-open");
            parent.find("li.active").removeClass("active");
            parent_li.addClass("active");
          });
        }
        if (checkElement.is(subMenuSelector)) {
          e.preventDefault();
        }
        return false;
      });
    };

    $.sidebarMenu($(".vertical-menu"));
    $(function () {
      for (
        var a = window.location,
          abc = $(".vertical-menu a")
            .filter(function () {
              return this.href == a;
            })
            .addClass("active")
            .parent()
            .addClass("active");
        ;

      ) {
        if (!abc.is("li")) break;
        abc = abc.parent().addClass("in").parent().addClass("active");
      }
    });
    /* -- Infobar Setting Sidebar -- */
    $("#infobar-settings-open").on("click", function (e) {
      e.preventDefault();
      $(".infobar-settings-sidebar-overlay").css({
        background: "rgba(0,0,0,0.4)",
        position: "fixed",
      });
      $("#infobar-settings-sidebar").addClass("sidebarshow");
    });
    $("#infobar-settings-close").on("click", function (e) {
      e.preventDefault();
      $(".infobar-settings-sidebar-overlay").css({
        background: "transparent",
        position: "initial",
      });
      $("#infobar-settings-sidebar").removeClass("sidebarshow");
    });
    /* -- Menu Hamburger -- */
    $(".menu-hamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("toggle-menu");
      $(".menu-hamburger img").toggle();
    });
    /* -- Menu Topbar Hamburger -- */
    $(".topbar-toggle-hamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("topbar-toggle-menu");
      $(".topbar-toggle-hamburger img").toggle();
    });
    /* -- Menu Scrollbar -- */
    /*$('.vertical-menu').slimscroll({
        height: '700px',
        position: 'right',
        size: "7px",
        color: '#CFD8DC',
    });*/
    /* -- Media Size -- */
    function mediaSize() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        $("body").removeClass("toggle-menu");
        $(".menu-hamburger img.menu-hamburger-close").hide();
        $(".menu-hamburger img.menu-hamburger-collapse").show();
      }
    }
    mediaSize();
    window.addEventListener("resize", mediaSize, false);

    /* -- Bootstrap Popover -- */
    $('[data-toggle="popover"]').popover();
    /* -- Bootstrap Tooltip -- */
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>

<style scoped>


</style>